import axios from 'axios'
import { Message, Loading } from 'element-ui'

// 创建8084端口的axios实例，使用环境变量中的基础路径
const service = axios.create({
  baseURL: process.env.VUE_APP_API_SERVICE_BASE_URL, // 从环境变量获取8084端口基础路径
  timeout: 15000, // 超时时间设置为15秒
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 加载实例（用于请求过程中的加载状态）
let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示加载状态
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    // 如果token存在，则添加到请求头
    if (token) {
      config.headers.Authorization = token
    }
    
    return config
  },
  (error) => {
    // 请求错误时关闭加载状态
    if (loadingInstance) loadingInstance.close()
    return Promise.reject(error)
  }
)

export default service
